export const ACCOUNT_SERVICE_INITIAL_LOAD = "ACCOUNT_SERVICE_INITIAL_LOAD";

const ALL = {
  ACCOUNT_SERVICE_INITIAL_LOAD,
};
export default ALL;
